// Define all permissions in the system
export const PERMISSIONS = {
  // User Management
  MANAGE_ALL_USERS: 'manage_all_users',
  MANAGE_CONFERENCE_USERS: 'manage_conference_users',
  VIEW_USERS: 'view_users',
  
  // Candidate Management
  MANAGE_ALL_CANDIDATES: 'manage_all_candidates',
  MANAGE_CONFERENCE_CANDIDATES: 'manage_conference_candidates',
  MANAGE_DISTRICT_CANDIDATES: 'manage_district_candidates',
  VIEW_ALL_CANDIDATES: 'view_all_candidates',
  VIEW_CONFERENCE_CANDIDATES: 'view_conference_candidates',
  VIEW_DISTRICT_CANDIDATES: 'view_district_candidates',
  INVITE_CANDIDATES: 'invite_candidates',
  
  // Form Management
  MANAGE_FORMS: 'manage_forms',
  VIEW_FORMS: 'view_forms',
  FILL_FORMS: 'fill_forms',
  
  // Document Management
  UPLOAD_DOCUMENTS: 'upload_documents',
  MANAGE_DOCUMENTS: 'manage_documents',
  VIEW_DOCUMENTS: 'view_documents',
  
  // Conference and District Management
  MANAGE_CONFERENCES: 'manage_conferences',
  MANAGE_DISTRICTS: 'manage_districts',
  VIEW_CONFERENCES: 'view_conferences',
  VIEW_DISTRICTS: 'view_districts',
  
  // Action Reports
  MANAGE_ACTION_REPORTS: 'manage_action_reports',
  VIEW_ACTION_REPORTS: 'view_action_reports',
  CREATE_ACTION_REPORT_TEMPLATES: 'create_action_report_templates',
  
  // CRC (Conference Relations Committee) Permissions - Archived
  // MANAGE_CRC_REQUESTS: 'manage_crc_requests',
  // VIEW_CRC_REQUESTS: 'view_crc_requests',
  // VOTE_ON_CRC_REQUESTS: 'vote_on_crc_requests',
  // MANAGE_CRC_MEETINGS: 'manage_crc_meetings',
  // VIEW_CRC_MEETINGS: 'view_crc_meetings',
  SYNC_COGNITO_FORMS: 'sync_cognito_forms',
  
  // Reports
  VIEW_REPORTS: 'view_reports',
  CREATE_REPORTS: 'create_reports',
  
  // Profile Management
  MANAGE_OWN_PROFILE: 'manage_own_profile',
  VIEW_OWN_PROFILE: 'view_own_profile'
};

// Define role-based permissions
export const ROLE_PERMISSIONS = {
  Admin: [
    // Full access to everything
    PERMISSIONS.MANAGE_ALL_USERS,
    PERMISSIONS.VIEW_USERS,
    PERMISSIONS.MANAGE_ALL_CANDIDATES,
    PERMISSIONS.VIEW_ALL_CANDIDATES,
    PERMISSIONS.INVITE_CANDIDATES,
    PERMISSIONS.MANAGE_FORMS,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.MANAGE_DOCUMENTS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.UPLOAD_DOCUMENTS,
    PERMISSIONS.MANAGE_CONFERENCES,
    PERMISSIONS.MANAGE_DISTRICTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    PERMISSIONS.MANAGE_ACTION_REPORTS,
    PERMISSIONS.VIEW_ACTION_REPORTS,
    PERMISSIONS.CREATE_ACTION_REPORT_TEMPLATES,
    // CRC permissions archived
    // PERMISSIONS.MANAGE_CRC_REQUESTS,
    // PERMISSIONS.VIEW_CRC_REQUESTS,
    // PERMISSIONS.VOTE_ON_CRC_REQUESTS,
    // PERMISSIONS.MANAGE_CRC_MEETINGS,
    // PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.SYNC_COGNITO_FORMS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.CREATE_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  
  Manager: [
    // Conference-level management
    PERMISSIONS.MANAGE_CONFERENCE_USERS,
    PERMISSIONS.VIEW_USERS,
    PERMISSIONS.MANAGE_CONFERENCE_CANDIDATES,
    PERMISSIONS.VIEW_CONFERENCE_CANDIDATES,
    PERMISSIONS.MANAGE_FORMS,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.MANAGE_DOCUMENTS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.UPLOAD_DOCUMENTS,
    PERMISSIONS.MANAGE_CONFERENCES,
    PERMISSIONS.MANAGE_DISTRICTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    PERMISSIONS.MANAGE_ACTION_REPORTS,
    PERMISSIONS.VIEW_ACTION_REPORTS,
    PERMISSIONS.CREATE_ACTION_REPORT_TEMPLATES,
    // CRC permissions archived
    // PERMISSIONS.MANAGE_CRC_REQUESTS,
    // PERMISSIONS.VIEW_CRC_REQUESTS,
    // PERMISSIONS.VOTE_ON_CRC_REQUESTS,
    // PERMISSIONS.MANAGE_CRC_MEETINGS,
    // PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.SYNC_COGNITO_FORMS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.CREATE_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  
  'BOM Registrar': [
    // Conference-level access with form management
    PERMISSIONS.VIEW_CONFERENCE_CANDIDATES,
    PERMISSIONS.MANAGE_FORMS,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.UPLOAD_DOCUMENTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    PERMISSIONS.MANAGE_ACTION_REPORTS,
    PERMISSIONS.VIEW_ACTION_REPORTS,
    // CRC permissions archived
    // PERMISSIONS.VIEW_CRC_REQUESTS,
    // PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  
  DS: [
    // District Superintendent - read-only plus invite capability
    PERMISSIONS.VIEW_DISTRICT_CANDIDATES,
    PERMISSIONS.INVITE_CANDIDATES,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    // CRC permissions archived
    // PERMISSIONS.VIEW_CRC_REQUESTS,
    // PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  
  'dCOM Chair': [
    // District Chair — full district management (at least as capable as a dCOM member)
    PERMISSIONS.MANAGE_DISTRICT_CANDIDATES,
    PERMISSIONS.VIEW_DISTRICT_CANDIDATES,
    PERMISSIONS.INVITE_CANDIDATES,
    PERMISSIONS.MANAGE_FORMS,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.MANAGE_DOCUMENTS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.UPLOAD_DOCUMENTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    PERMISSIONS.MANAGE_ACTION_REPORTS,
    PERMISSIONS.VIEW_ACTION_REPORTS,
    PERMISSIONS.CREATE_ACTION_REPORT_TEMPLATES,
    // CRC permissions archived
    // PERMISSIONS.VIEW_CRC_REQUESTS,
    // PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.CREATE_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  
  dCOM: [
    // District Committee on Ordained Ministry - full district-level management
    PERMISSIONS.MANAGE_DISTRICT_CANDIDATES,
    PERMISSIONS.VIEW_DISTRICT_CANDIDATES,
    PERMISSIONS.INVITE_CANDIDATES,
    PERMISSIONS.MANAGE_FORMS,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.MANAGE_DOCUMENTS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.UPLOAD_DOCUMENTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    PERMISSIONS.MANAGE_ACTION_REPORTS,
    PERMISSIONS.VIEW_ACTION_REPORTS,
    PERMISSIONS.CREATE_ACTION_REPORT_TEMPLATES,
    // CRC permissions archived
    // PERMISSIONS.VIEW_CRC_REQUESTS,
    // PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.CREATE_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  
  'dCOM Member': [
    // District Committee on Ordained Ministry Member - read-only version of dCOM
    PERMISSIONS.VIEW_DISTRICT_CANDIDATES,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    PERMISSIONS.VIEW_ACTION_REPORTS,
    // CRC permissions archived
    // PERMISSIONS.VIEW_CRC_REQUESTS,
    // PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  
  // 'CRC Member' role archived - uncomment if needed
  /*
  'CRC Member': [
    // Conference Relations Committee member
    PERMISSIONS.VIEW_CRC_REQUESTS,
    PERMISSIONS.VOTE_ON_CRC_REQUESTS,
    PERMISSIONS.VIEW_CRC_MEETINGS,
    PERMISSIONS.VIEW_FORMS,
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.VIEW_CONFERENCES,
    PERMISSIONS.VIEW_DISTRICTS,
    PERMISSIONS.VIEW_REPORTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ],
  */
  
  Candidate: [
    // Limited access to own profile and assigned forms
    PERMISSIONS.FILL_FORMS,
    PERMISSIONS.UPLOAD_DOCUMENTS,
    PERMISSIONS.VIEW_DOCUMENTS,
    PERMISSIONS.MANAGE_OWN_PROFILE,
    PERMISSIONS.VIEW_OWN_PROFILE
  ]
};

// Utility function to check if a user has a specific permission
export const hasPermission = (user, permission) => {
  if (!user || !user.role) {
    return false;
  }
  
  const rolePermissions = ROLE_PERMISSIONS[user.role] || [];
  return rolePermissions.includes(permission);
};

// Utility function to check if a user has any of the specified permissions
export const hasAnyPermission = (user, permissions) => {
  if (!user || !user.role || !Array.isArray(permissions)) {
    return false;
  }
  
  return permissions.some(permission => hasPermission(user, permission));
};

// Utility function to check if a user has all of the specified permissions
export const hasAllPermissions = (user, permissions) => {
  if (!user || !user.role || !Array.isArray(permissions)) {
    return false;
  }
  
  return permissions.every(permission => hasPermission(user, permission));
};

// Utility function to get all permissions for a user's role
export const getUserPermissions = (user) => {
  if (!user || !user.role) {
    return [];
  }
  
  return ROLE_PERMISSIONS[user.role] || [];
};

// Utility function to check if user can access conference-specific data
export const canAccessConference = (user, conferenceId) => {
  if (!user) return false;
  
  // Admins can access everything
  if (user.role === 'Admin') return true;
  
  // Conference-level roles can only access their own conference
  if (['Manager', 'BOM Registrar'].includes(user.role)) {
    return user.conferenceId === conferenceId;
  }
  
  return false;
};

// Utility function to check if user can access district-specific data
export const canAccessDistrict = (user, districtId) => {
  if (!user) return false;
  
  // Admins can access everything
  if (user.role === 'Admin') return true;
  
  // Conference-level roles can access all districts in their conference.
  // TODO: enhance with district-to-conference mapping once conference data
  //       is structured in Firestore (currently no district→conference index).
  if (['Manager', 'BOM Registrar'].includes(user.role)) {
    return true;
  }
  
  // District-level roles can only access their own district(s)
  if (['DS', 'dCOM Chair'].includes(user.role)) {
    return user.districtId === districtId;
  }
  
  // dCOM and dCOM Member roles can access multiple districts
  if (['dCOM', 'dCOM Member'].includes(user.role)) {
    const userDistrictIds = user.districtIds || (user.districtId ? [user.districtId] : []);
    return userDistrictIds.includes(districtId);
  }
  
  return false;
};

// Returns true for any role that is NOT a plain Candidate
export const isStaffRole = (role) =>
  role != null && role !== 'Candidate';

// Export all available roles
export const AVAILABLE_ROLES = Object.keys(ROLE_PERMISSIONS);

// CRC-specific status constants
export const CRC_STATUS = {
  PENDING: 'pending',
  UNDER_REVIEW: 'under-review',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  SENT_TO_BOM: 'sent-to-bom',
  BOM_APPROVED: 'bom-approved',
  BOM_REJECTED: 'bom-rejected'
};

// CRC vote types
export const CRC_VOTE_TYPES = {
  APPROVE: 'approve',
  REJECT: 'reject',
  ABSTAIN: 'abstain'
};
